import { useEffect, useState, useContext } from 'react';
import { Container, Typography, Stack, Box, CircularProgress } from '@mui/material';
import { ReqCutiForm } from '../../../sections/cabang/cuti';
import { axiosPrivate } from '../../../common/axiosPrivate';
import AuthContext from '../../../context/authContext';

const EditReqCutiPage = ({id, handleCloseModal, handleUpdateTable}) => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState({});
  const [dropDown, setDropDown] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setPageLoading(true);

    const getDropdown = async () => {
      try {
        let dropdownData = [];
        // --- ROLE BASED ---
        if (user?.role === 'area' && user?.kantorList?.length > 0) {
          // Area: POST kantorList + role
          const response = await axiosPrivate.get('req-cuti/dropdown/list', {
            params: {
              kantorList: user.kantorList.join(','),
              role: user.role
            }
          });
          dropdownData = response?.data;
        } else if (user?.role === 'pusat') {
          // Pusat: POST hanya role, backend return semua kantor
          const response = await axiosPrivate.post(`req-cuti/dropdown/list`, {
            role: user.role
          });
          dropdownData = response?.data;
        } else if (user?.kantor) {
          // Lainnya: GET single kantor
          const response = await axiosPrivate.get(`req-cuti/dropdown/list/${user.kantor}`);
          dropdownData = response?.data;
        }
        setDropDown(dropdownData);

        // --- GET CUTI DATA BY ID ---
        if (id) {
          const res = await axiosPrivate.get(`/req-cuti/pegawai/${id}`);
          const resData = res.data;
          const objectKey = resData.attachment;

          // Adjust the image URL if necessary
          if (objectKey && objectKey.startsWith('/sip-photos')) {
            const formattedKey = objectKey.startsWith('/') ? objectKey.substring(1) : objectKey;
            const file = await axiosPrivate.post(`/files/signed-url`, { key: formattedKey });
            resData.attachment = file?.data?.signedUrl;
          }
          setData(resData);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setPageLoading(false);
      }
    };

    getDropdown();
  }, [id, user?.kantor, user?.role, user?.kantorList]);

  return (
    <>
      {pageLoading ? (
        <Box
          sx={{
            flexGrow: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          width={"100%"}
        >
          <CircularProgress />
        </Box>) : (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Ubah Request Cuti
            </Typography>
          </Stack>
          <ReqCutiForm
            data={data}
            dropDown={dropDown}
            handleCloseModal={handleCloseModal}
            handleUpdateTable={handleUpdateTable}
          />
        </Container>
      )}
    </>
  );
}
  
export default EditReqCutiPage;
